module.exports = __webpack_public_path__ + "static/media/first-aid-strat.19140dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/RepairPage/assets/first-aid-strat.png
// module id = 534
// module chunks = 0